<div class="content bg-gray-lighter ng-scope">
  <div class="row items-push">
    <div class="col-md-6">
      <h1 class="page-heading">
        <ng-transclude></ng-transclude>
      </h1>
    </div>
  </div>
</div>
